import {
  LOGIN_MEMBER_START,
  LOGIN_MEMBER_SUCCESS,
  LOGIN_MEMBER_ERROR,
  LOGIN_FORM_UPDATED,
  LOGOUT_MEMBER,
  GET_USER_INFO,
  SET_REDIRECT_URI_START,
  SET_REDIRECT_URI_SUCCESS,
  USER_REGISTRATION_START,
  USER_REGISTRATION_SUCCESS,
  USER_REGISTRATION_FAILURE,
  GET_USER_ID_START, GET_USER_ID_SUCCESS, GET_USER_ID_FAILURE, RESET_ERROR_MESSAGE,
  VERIFY_TOKEN_START, VERIFY_TOKEN_SUCCESS, VERIFY_TOKEN_FAILURE,
  RESET_PASSWORD_START, RESET_PASSWORD_FAILURE, RESET_PASSWORD_SUCCESS
} from './types';
import API from './api';
import UserManager from '../../components/utils/UserManager';

export const loginFormChanged = () => async dispatch => {
  dispatch({ type: LOGIN_FORM_UPDATED, errorMessage: '', loading: false });
};

export const login = (username, password, isDeveloper, callback) => async dispatch => {
  //console.log('inside login');
  try {
    dispatch({ type: LOGIN_MEMBER_START });
    let url = '/api/auth';
    let signInUser = {
      args: {
        userID: username,
        password: password
      }
    };
    if (isDeveloper) {
      url = "/blockchain-api/v1/developer-authentication";
      signInUser = {
          userId: username,
          password: password
      };
    }
    // console.log("You Are inside Login", url);
    const response = await API.post(url, signInUser);
    if (response.data) {
      //console.log('>>> ' + response.data.token);
      UserManager.reset();
      if (isDeveloper) {
        localStorage.setItem('myElthDeveloper', JSON.stringify(response.data));
      } else {
        localStorage.setItem('myElthSessionUser', JSON.stringify(response.data));
      }
      // console.log(`Response from login: ${JSON.stringify(response.data)}`);
      dispatch({ type: LOGIN_MEMBER_SUCCESS, payload: response.data });
      callback();
    } else {
      //console.log("response not available");
      dispatch({ type: LOGIN_MEMBER_ERROR, payload: 'Authentication Failed' });
    }
  } catch (e) {
    console.log('authentication error message ' + e);
    dispatch({ type: LOGIN_MEMBER_ERROR, payload: 'Authentication Failed' });
  }
};

export const logout = () => dispatch => {
  localStorage.removeItem('myElthSessionUser');
  localStorage.removeItem('myElthDeveloper');
  dispatch({ type: LOGOUT_MEMBER, payload: {} });
};

export const getUser = (getType) => dispatch => {
  let userStr = localStorage.getItem('myElthSessionUser');
  if (getType) {
    userStr = localStorage.getItem(getType);
  }
  // console.log(JSON.stringify(userStr));
  let userObj = undefined;
  if (userStr) {
    userObj = JSON.parse(userStr);
  }
  if (userObj) {
    let userID = userObj.userID;
    let userFirstName = userObj.firstName;
    let userLasName = userObj.lastName;
    dispatch({
      type: GET_USER_INFO,
      payload: {
        userID: userID,
        firstName: userFirstName,
        lastName: userLasName,
        userObj: userObj
      }
    });
  }
};

export const registerUser = (userEntity, callback) => async dispatch => {
  dispatch({ type: USER_REGISTRATION_START });
  try {
      const url = `/api/Users`;
      // console.log("calling user registration...");
      // console.log(JSON.stringify(userEntity));
      const response = await API.post(url, { "args": { ...userEntity } });
      if(response.data){
        // console.log("success with user registration");
        dispatch({type: USER_REGISTRATION_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        // console.log("failure with user registration");
        dispatch({type: USER_REGISTRATION_FAILURE, payload: 'No Response for User Registration'});    
      }
  } catch (e) {
      dispatch({type: USER_REGISTRATION_FAILURE, errorMessage: e});
  }
}

export const getRedirectURI= uri => async dispatch => {
  // console.log('action member : ' + JSON.stringify(uri));
  dispatch({ type: SET_REDIRECT_URI_START, loading: true });
  if (uri) {
    dispatch({
      type: SET_REDIRECT_URI_SUCCESS,
      payload: uri,
      loading: false,
      errorMessage: ''
    });
  }
};

export const forgetUserId = (params, callback) => async dispatch => {
  dispatch({ type: GET_USER_ID_START });
  const url =`/myelth-idm-services/v1/member-forgot-userid`;
  try {
      const response = await API.post(url, params);
      if(response.data){
        dispatch({type: GET_USER_ID_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_USER_ID_FAILURE, payload: 'No Response for forget user ID'});    
      }
  } catch (e) {
      dispatch({type: GET_USER_ID_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}


export const forgetPassword = (params, callback) => async dispatch => {
  dispatch({ type: GET_USER_ID_START });
  const url = "/myelth-idm-services/v1/member-forgot-pwd";
  try {
      const response = await API.post(url, params);
      if(response.data){
        dispatch({type: GET_USER_ID_SUCCESS, payload: response.data, userInfo: params});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: GET_USER_ID_FAILURE, payload: 'No Response for forget user ID'});    
      }
  } catch (e) {
      dispatch({type: GET_USER_ID_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}

export const resetErrorMsg = {
  type: "RESET_ERROR_MESSAGE"
}

export const verifyToken = (params, callback) => async dispatch => {
  dispatch({ type:  VERIFY_TOKEN_START });
  const url = "/myelth-idm-services/v1/member-pwd-token-verify";
  try {
      const response = await API.post(url, params);
      if(response.data){
        dispatch({type: VERIFY_TOKEN_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: VERIFY_TOKEN_FAILURE, payload: 'No Response for VERIFY TOKEN'});    
      }
  } catch (e) {
      dispatch({type: VERIFY_TOKEN_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}

export const changePassword = (params, callback) => async dispatch => {
  dispatch({ type: RESET_PASSWORD_START });
  const url = "/myelth-idm-services/v1/member-change-pwd";
  try {
      const response = await API.post(url, params);
      if(response.data){
        dispatch({type: RESET_PASSWORD_SUCCESS, payload: response.data});
        if (callback) {
          callback();
        }
      } else {
        dispatch({type: RESET_PASSWORD_FAILURE, payload: 'No Response for change password'});    
      }
  } catch (e) {
      dispatch({type: RESET_PASSWORD_FAILURE, errorMessage: e && e.response && e.response.data && e.response.data.message});
  }
}